interface AccessDeniedMessageProps {
  title?: string;
  description?: string;
  className?: string;
}

const DEFAULT_TITLE = 'Hozzáférés megtagadva';
const DEFAULT_DESCRIPTION = 'Csak az adminisztrátorok érhetik el ezt a részt.';

export default function AccessDeniedMessage({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  className = '',
}: AccessDeniedMessageProps) {
  return (
    <div
      className={`flex items-center justify-center min-h-[40vh] ${className}`}
      role="alert"
    >
      <div className="text-center max-w-sm">
        <h2 className="text-xl font-semibold mb-2">{title}</h2>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
